/* eslint-disable @typescript-eslint/no-var-requires */
export const PhoenixBookHotelHeaderData = require('./queries/PhoenixBookHotelHeaderData.graphql');
export const PhoenixBookHotelHeaderDataAuth = require('./queries/PhoenixBookHotelHeaderDataAuth.graphql');
export const PhoenixBookUpdateSaveProperties = require('./mutations/PhoenixBookUpdateSaveProperties.graphql');
